"use strict"

import React, { useState, useCallback } from "react"
import { FormattedMessage } from "react-intl"
import { Button } from "react-bootstrap"

import { withSampleConfig } from "../../../config/SampleConfigProvider"
import TableSampleAnalysisStatus from "./TableSampleAnalysisStatus"
import ModalPrintLabels from "./modals/ModalPrintLabels"
import { hideModal } from "../../../shared_components/utils"
import { getFormattedMessage } from "../../shared_components_registration"

const UploadDataTab = ({
  reloadSampleTable,
  downloadSampleTable,
  querySamples,
  isNSView,
  can_print_skokie = false,
}) => {
  const [downloadDisabled, setDownloadDisabled] = useState(true)
  const [showPrintLabelModal, setShowPrintLabelsModal] = useState(false)
  const [availablePrinters, setAvailablePrinters] = useState({})
  const [samples, setSamples] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchPrintableSamples = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await querySamples({ filters: { status: "pending_analysis" } }, false, true)
      setSamples(response.data) // Store the fetched samples in state
    } catch (error) {
      console.error("Error fetching samples:", error)
    } finally {
      setIsLoading(false)
    }
  }, [querySamples])

  // Handle opening the print modal
  const handlePrintLabelsClick = async () => {
    if (samples.length === 0) {
      await fetchPrintableSamples() // Fetch samples if not already loaded
    }
    setShowPrintLabelsModal(true)
  }

  return (
    <>
      <div className={"row"}>
        <div className={"col-4"}>
          <div style={{ margin: "5px 0px" }}>
            <span className={"fa fa-arrow-circle-o-up"} />
            &nbsp;&nbsp;
            {getFormattedMessage(
              `samplemanagement.tab.upload.${isNSView ? "ns" : "sample"}.data`,
              `Upload ${isNSView ? "NS" : "Sample"} Data`,
            )}
          </div>
        </div>
        <div className={"col-8"} align={"right"}>
          <Button
            variant={"outline-primary"}
            size={"sm"}
            onClick={() => reloadSampleTable()}
            style={{ marginRight: "5px" }}
          >
            <span className={"fa fa-refresh"} />
            &nbsp;
            <FormattedMessage id={"general.refresh"} description={"Sample Table Refresh Data Button"} />
          </Button>
          <Button
            variant={"outline-primary"}
            size={"sm"}
            onClick={() => downloadSampleTable()}
            disabled={downloadDisabled}
          >
            <span className={"fa fa-file-excel-o"} />
            &nbsp;
            <FormattedMessage id={"general.download"} description={"Sample Table Download Data Button"} />
          </Button>
          {can_print_skokie && (
            <>
              &nbsp;
              <Button
                variant={"outline-primary"}
                size={"sm"}
                onClick={handlePrintLabelsClick}
                disabled={isLoading}
              >
                {isLoading && (
                  <>
                    <div
                      className="spinner-border spinner-border-sm text-primary text-center"
                      role="status"
                    />
                    &nbsp;
                  </>
                )}
                <span className={"fa fa-print"} />
                &nbsp;
                <FormattedMessage
                  id={"samplemanagement.print.labels"}
                  description={"Sample Table Print Data Button"}
                />
              </Button>
            </>
          )}
        </div>
      </div>

      <TableSampleAnalysisStatus setDownloadDisabled={setDownloadDisabled} />

      {showPrintLabelModal && (
        <ModalPrintLabels
          sample={samples}
          show={showPrintLabelModal}
          printers={availablePrinters}
          setPrinters={setAvailablePrinters}
          onHide={() => hideModal(setShowPrintLabelsModal)}
          onSuccess={() => hideModal(setShowPrintLabelsModal)}
        />
      )}
    </>
  )
}

export default withSampleConfig(UploadDataTab)
